import { render, staticRenderFns } from "./AddQuestionModal.vue?vue&type=template&id=1fc2dd0a&scoped=true"
import script from "./AddQuestionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddQuestionModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddQuestionModal.vue?vue&type=style&index=0&id=1fc2dd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2dd0a",
  null
  
)

export default component.exports